import React from "react";
import {BestValue} from "./types";

export interface BestValueTagProps {
    bestValue: BestValue;
}

const BestValueTag = ({bestValue}: BestValueTagProps) => {
    return (
        <pui-section class="best-value-tag" flowdirection="horizontal">
            <pui-text input="Best value" textsize="medium" textColor="white" spacingleft="med-small" spacing="mini"/>
            <pui-bottom-sheet icon="info-icon-white" iconwidth="15px" iconheight="15px" spacingright="med-small">
                <p className="bottom-sheet-header">{bestValue.bestValueHeader}</p>
                <p className="bottom-sheet-content">{bestValue.bestValueDescription}</p>
            </pui-bottom-sheet>
        </pui-section>
    )
}

export default BestValueTag;